import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=75e5e96d"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports